import axios from 'axios';

export const fetchRegionais = async (page = 1, limit = 10) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/contac-sga-regionais?page=${page}&limit=${limit}`;

    const response = await axios.get(url, {
      withCredentials: true,
    });

    return response.data;
  } catch (error: unknown) {
    console.error('❌ Erro ao buscar regionais:', error);

    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar regionais');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};
